import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import {
  FaSatellite,
  FaCube,
  FaDownload,
} from 'react-icons/fa';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import useWeatherInfo from './useWeatherInfo';
import TemperatureOverlay from './TemperatureOverlay';
import WindOverlay from './WindOverlay';
import { convertToCSV, downloadCSVFile } from '../../../helper/scheduleHelper';
import { flattenAnomalyArrayForCsv } from '../../../helper/mapHelper';

export default function MapControlButtons({
  selectedImageryData,
  dispatchMap,
  isBottomSheetVisible,
  isImageryPanelVisible,
  selectedObjFromState,
  ranchId,
  blockId,
  isMobile,
  anomalyGeoJSON,
  presMode,
}) {
  const [weatherInfo, isWeatherLoading] = useWeatherInfo();
  const { t } = useTranslation();

  function onClickButton(type) {
    if (type === 'satellite') {
      dispatchMap({
        type: 'setIsImageryPanelVisible',
        payload: !isImageryPanelVisible,
      });
      if (!isBottomSheetVisible) {
        dispatchMap({
          type: 'setIsBottomSheetVisible',
          payload: !isBottomSheetVisible,
        });
      }
      if (!selectedImageryData.visible) {
        dispatchMap({
          type: 'setSelectedImageryData',
          payload: {
            visible: true,
            data: selectedImageryData.data,
          },
        });
      }
    }
    if (type === '3d') {
      dispatchMap({ type: 'setShowMap3D', payload: true });
      dispatchMap({
        type: 'setSideBySideMapVisible',
        payload: false,
      });
      dispatchMap({
        type: 'setIsBottomSheetVisible',
        payload: false,
      });
    }
    if (type === 'anomaly-csv-download') {
      const fileName = `FarmX-Anomalies-${moment().format('YYYY-MM-DD HH:mm:ss')}.csv`;
      const csvData = convertToCSV(flattenAnomalyArrayForCsv(anomalyGeoJSON));
      downloadCSVFile(csvData || t('No data'), fileName);
    }
  }

  return (
    <>
      {!isMobile && blockId && selectedObjFromState.type === 'block' ? (
        <Button
          id="3d"
          size="large"
          type="primary"
          ghost={false}
          style={{ width: '40px', marginTop: '10px' }}
          icon={<FaCube style={{ marginTop: '5px' }} />}
          onClick={(d) => onClickButton(d.currentTarget.id)}
        />
      ) : null}
      {presMode === 'anomaly' && anomalyGeoJSON ? (
        <Button
          id="anomaly-csv-download"
          size="large"
          type="primary"
          ghost={false}
          style={{ width: '40px', marginTop: '10px' }}
          icon={<FaDownload style={{ marginTop: '5px' }} />}
          onClick={(d) => onClickButton(d.currentTarget.id)}
        />
      ) : null}
      <Button
        id="satellite"
        size="large"
        disabled={!ranchId}
        type={isImageryPanelVisible ? 'primary' : 'secondary'}
        ghost={false}
        style={{ width: '40px', marginTop: '10px' }}
        icon={<FaSatellite style={{ marginTop: '5px' }} />}
        onClick={(d) => onClickButton(d.currentTarget.id)}
      />
      <TemperatureOverlay
        value={weatherInfo.temperature.value}
        label={weatherInfo.temperature.label}
        isLoading={isWeatherLoading}
      />
      <WindOverlay
        value={weatherInfo.wind}
        windDirection={weatherInfo.windDirection}
        isLoading={isWeatherLoading}
      />
    </>
  );
}

MapControlButtons.propTypes = {
  isMobile: PropTypes.bool,
  isImageryPanelVisible: PropTypes.bool,
  ranchId: PropTypes.number.isRequired,
  blockId: PropTypes.number.isRequired,
  selectedObjFromState: PropTypes.shape().isRequired,
  anomalyGeoJSON: PropTypes.shape(),
  dispatchMap: PropTypes.func,
  selectedImageryData: PropTypes.shape(),
  isBottomSheetVisible: PropTypes.bool,
  presMode: PropTypes.string.isRequired,
};

MapControlButtons.defaultProps = {
  isMobile: false,
  isImageryPanelVisible: false,
  dispatchMap: null,
  selectedImageryData: null,
  isBottomSheetVisible: false,
  anomalyGeoJSON: {},
};
